module.exports = __webpack_public_path__ + "162a893018043276888a4d52695fcce0.svg";